import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    text: '"Hice el primer ritual llorando. Pero después sentí algo que hacía meses no sentía — que algo terminó de verdad. No \'de boca para afuera\'."',
    author: '— Valentina R., 38 años · Buenos Aires'
  }, {
    text: '"Había ido a terapia durante un año y entendía todo. Pero el cierre nunca llegó hasta que hice el ritual 7. Algo se soltó de verdad."',
    author: '— Camila S., 43 años · Santiago'
  }, {
    text: '"El Bono 2 fue lo que más me ayudó. Los rituales de emergencia para cuando el pasado te aparece de golpe. Los tengo siempre a mano."',
    author: '— Daniela M., 35 años · México DF'
  }];
  return <section id="testimonials" className="py-12 md:py-16 text-center" style={{
    background: 'var(--nude-warm)'
  }} data-id="element-274">
      <div className="max-w-[960px] mx-auto px-5" data-id="element-275">
        <p className="text-[10px] tracking-[4px] uppercase text-center mb-2.5" style={{
        color: 'var(--rose-deep)'
      }} data-id="element-276">
          Resultados reales
        </p>

        <h2 className="font-serif font-normal max-w-[600px] mx-auto mb-8" style={{
        fontSize: 'clamp(24px, 4.5vw, 42px)',
        color: 'var(--ink)'
      }} data-id="element-277">
          Algo que llevaban meses cargando,
          <br data-id="element-278" />
          <em style={{
          color: 'var(--rose-deep)'
        }} data-id="element-279">
            finalmente se movió
          </em>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-280">
          {testimonials.map((testimonial, index) => <div key={index} className="fade-in rounded-2xl p-6 text-left" style={{
          background: 'var(--white)',
          boxShadow: '0 4px 24px rgba(180,122,138,.1)'
        }} data-id="element-281">
              <div className="text-[12px] tracking-widest mb-3" style={{
            color: 'var(--gold)'
          }} data-id="element-282">
                ★★★★★
              </div>
              <p className="font-serif text-[15px] italic leading-relaxed mb-4" style={{
            color: 'var(--ink-soft)'
          }} data-id="element-283">
                {testimonial.text}
              </p>
              <p className="text-[10px] tracking-widest uppercase" style={{
            color: 'var(--rose-deep)'
          }} data-id="element-284">
                {testimonial.author}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}